<template>
  <div class="talk-box">
    <div class="img-box">
      <img :src="image_src" class="icon" alt="" />
    </div>
    <div class="talk">
      <p class="txt01"><slot></slot></p>
    </div>
  </div>
</template>

<script>
export default {
  name: "TalkBox",
  props: {
    src: { type: String, default: "" },
  },
  computed: {
    image_src() {
      return require("@/assets/images/sv/" + this.src);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/stylesheets/styles";

.talk-box {
  margin-bottom: 20px;
  background-color: #fff;
  color: #333333;
  display: flex;
  align-items: center;
  > .img-box {
    max-width: 80px;
    > .icon {
      width: 80px;
      @include mq-down(md) {
        width: 50px;
      }
    }
  }
  > .talk {
    > .txt01 {
      padding-top: 8px;
      padding-bottom: 8px;
      border-left: 1px solid $secondary;
      padding-left: 15px;
      margin-left: 15px;
      margin-bottom: 0;
      @include mq-up(md) {
        padding-top: 16px;
        padding-bottom: 16px;
        padding-left: 20px;
        margin-left: 30px;
      }
      :deep(.strong) {
        font-size: 20px;
        font-weight: normal;
      }
    }
  }
}
</style>
